import React from 'react';
import PropTypes from 'prop-types';

const Instructions = ({ text }) => (
  <p className="mb4">
    {text}
  </p>
);

Instructions.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Instructions;
